import { api } from "@/plugins/api";

const state = {
  meters: [],
};

const getters = {
  getAllMeters: (state) => state.meters,

  getMeterById: (state) => (id) =>
    state.meters.filter((meter) => meter.id === id),
};

const actions = {
  async fetchAllMeters({ commit }) {
    try {
      const response = await api.get("/meters");
      const meters = response.data.data;
      commit("setMeters", meters);
      //return { status: response.status, msg: response.data.message };
      return true;
    } catch (error) {
      //return { status: error.response.status, msg: error.message };
      return false;
    }
  },
  async fetchAllMeters_lite({ commit }) {
    try {
      const response = await api.get("/meters_lite");
      const meters = response.data.data;
      commit("setMeters", meters);
      //return { status: response.status, msg: response.data.message };
      return true;
    } catch (error) {
      //return { status: error.response.status, msg: error.message };
      return false;
    }
  },
  async addMeter({ commit }, meter) {
    try {
      //console.log("passed data", meter);
      const response = await api.post("/meters", meter);
      //console.log("response", response);
      commit("addMeter", response.data.data);
      return true;
    } catch (error) {
      return false;
    }
  },
  async updateMeter({ commit }, meter) {
    try {
      const id = meter.id;
      console.log("passed data", meter);
      meter._method = "put";
      //meter.isFinal = 1;
      const response = await api.post(`/meters/${id}`, meter);
      //console.log("updated", response.data);
      commit("updateMeter", response.data.data);
      return true;
    } catch (error) {
      //console.log("error", error.message);
      return false;
    }
  },
  async deleteMeter({ commit }, id) {
    try {
      //const response = await api.delete(`/meters/${id}`);
      const response = await api.delete(`/meters/${id}`);
      console.log("response", response);
      if (response) {
        commit("removeMeter", id);
      }
      //return response.data.message;
      return true;
    } catch (error) {
      //console.log("response", error);
      //return error.message;
      return false;
    }
  },
};

const mutations = {
  setMeters(state, meters) {
    state.meters = meters;
    //console.log("mu", state.meters);
  },
  addMeter(state, meter) {
    //console.log("uses is:", meter);
    state.meters.unshift(meter);
    //console.log("uses updated:", state.meters);
  },
  removeMeter(state, id) {
    const index = state.meters.findIndex((meter) => meter.id == id);
    if (index !== -1) {
      state.meters.splice(index, 1);
    }
  },
  updateMeter(state, meter) {
    const id = meter.id;
    const index = state.meters.findIndex((meter) => meter.id == id);
    if (index !== -1) {
      state.meters[index] = meter;
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
